/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimRolesResponseDto } from '../models/clm-claim-roles-response-dto';


/**
 * the ClaQueryReadRoles API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadRolesService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdRolesGet
   */
  static readonly ClaimClaimIdRolesGetPath = '/claim/{claimId}/roles';

  /**
   * Get roles by product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRolesGet$Response(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimRolesResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadRolesService.ClaimClaimIdRolesGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimRolesResponseDto>;
      })
    );
  }

  /**
   * Get roles by product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRolesGet(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClmClaimRolesResponseDto> {

    return this.claimClaimIdRolesGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimRolesResponseDto>) => r.body as ClmClaimRolesResponseDto)
    );
  }

}
